export default "__VITE_ASSET__B1sZ11g5__"